import { Resource } from "@/types/resource";
import ResourceCard from "./ResourceCard";

interface ResourceListProps {
  resources: Resource[];
}

const ResourceList = ({ resources }: ResourceListProps) => {
  // Filter out test resources from production view
  const filteredResources = [...resources].filter(resource => !resource.name.includes('TEST')).sort((a, b) => {
    // First, sort by availability (unavailable goes last)
    if (a.availability === 'unavailable' && b.availability !== 'unavailable') return 1;
    if (a.availability !== 'unavailable' && b.availability === 'unavailable') return -1;
    
    // Then sort by created_at within each availability group
    const dateA = new Date(a.created_at || 0);
    const dateB = new Date(b.created_at || 0);
    return dateB.getTime() - dateA.getTime();
  });

  console.log('Resources after filtering out test resources:', filteredResources); // Debug log

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
      {filteredResources.map((resource) => (
        <ResourceCard key={resource.id} resource={resource} />
      ))}
    </div>
  );
};

export default ResourceList;